<ng-container *transloco="let t; read: 'home'">
  <div class="benefits p-grid p-nogutter p-jc-center">
    <div class="benefits__wrapper p-grid p-nogutter p-jc-center">
      <div class="p-col-12 p-text-center">
        <h2 class="home-heading p-text-uppercase">
          {{ t('benefits.header.part1')
          }}<span>{{ t('benefits.header.part2') }}</span>
        </h2>
        <h2 class="home-heading p-text-normal">{{ t('benefits.header.part3') }}</h2>
      </div>

      <div class="p-col-12 p-xl-4">
        <div class="p-grid p-nogutter">
          <div class="p-col-12 p-md-6 p-xl-12">
            <div class="benefits__tale p-shadow-9 p-md-m-1">
              <img
                class="picture circle-image"
                src="assets/images/04_Kluczyki_BMW.webp"
                alt="calculator"
                loading="lazy"
                decoding="async" width="640" height="640">
              <p>
                {{ t('benefits.content.col1') }}
              </p>
              <div class="calculationLink">
                <img
                  src="assets/icons/calculator.svg"
                  alt="calculator"
                  loading="lazy"
                  decoding="async" width="21" height="27">
                <a
                  href="#home__left"
                  (click)="scrollToCalculator($event)"
                  class="textYellow"
                  >{{ t('benefits.content.calculate') }}</a
                >
              </div>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-xl-12">
            <div class="benefits__tale p-shadow-9 p-md-m-1">
              <img
                class="picture circle-image"
                src="assets/images/05_EV_ladowanie.webp"
                alt="jaguar"
                loading="lazy"
                decoding="async" width="640" height="640">
              <h3 class="p-text-bold">
                {{ t('benefits.content.col2.header') }}
              </h3>
              <p>
                {{ t('benefits.content.col2.part1') }}
              </p>
              <div class="calculationLink">
                <a
                  class="textYellow"
                  [href]="formUrl('/cta/buy-gap', 'ctaHeader')"
                  >{{ t('benefits.content.col2.link') }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-col-12 p-xl-8 p-grid">
        <div class="benefits__videoTab">
          <h2 class="p-text-center p-mb-3">{{ t('benefits.videoHeader') }}</h2>
          <div class="benefits__videoTab__content">
            <div
              class="ytFacade"
              *ngIf="typeOfPolicy === 'invoice'">
              <button
                *ngIf="activeVideo !== 'invoice'"
                type="button"
                class="ytFacade__poster"
                (click)="startVideo('invoice')"
                [attr.aria-label]="t('benefits.videoHeader')">
                <img
                  src="https://i.ytimg.com/vi/D-O_t3OXXiI/hqdefault.jpg"
                  alt=""
                  loading="lazy"
                  decoding="async"
                  width="480"
                  height="360" />
                <span class="ytFacade__play" aria-hidden="true"></span>
              </button>
              <iframe
                *ngIf="activeVideo === 'invoice'"
                src="https://www.youtube.com/embed/D-O_t3OXXiI?autoplay=1"
                title="GAP invoice"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                loading="lazy"></iframe>
            </div>
            <div
              class="ytFacade"
              *ngIf="typeOfPolicy === 'casco'">
              <button
                *ngIf="activeVideo !== 'casco'"
                type="button"
                class="ytFacade__poster"
                (click)="startVideo('casco')"
                [attr.aria-label]="t('benefits.videoHeader')">
                <img
                  src="https://i.ytimg.com/vi/FO452vk1b9s/hqdefault.jpg"
                  alt=""
                  loading="lazy"
                  decoding="async"
                  width="480"
                  height="360" />
                <span class="ytFacade__play" aria-hidden="true"></span>
              </button>
              <iframe
                *ngIf="activeVideo === 'casco'"
                src="https://www.youtube.com/embed/FO452vk1b9s?autoplay=1"
                title="GAP casco"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                loading="lazy"></iframe>
            </div>
            <div
              class="ytFacade"
              *ngIf="typeOfPolicy === 'direct'">
              <button
                *ngIf="activeVideo !== 'direct'"
                type="button"
                class="ytFacade__poster"
                (click)="startVideo('direct')"
                [attr.aria-label]="t('benefits.videoHeader')">
                <img
                  src="https://i.ytimg.com/vi/ev6rTYMKdss/hqdefault.jpg"
                  alt=""
                  loading="lazy"
                  decoding="async"
                  width="480"
                  height="360" />
                <span class="ytFacade__play" aria-hidden="true"></span>
              </button>
              <iframe
                *ngIf="activeVideo === 'direct'"
                src="https://www.youtube.com/embed/ev6rTYMKdss?autoplay=1"
                title="GAP direct"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                loading="lazy"></iframe>
            </div>
          </div>
          <div
            class="benefits__videoTab__header p-grid p-nogutter p-text-center p-ai-center">
            <div
              class="p-col-12 p-md-4 header-stretch"
              (mouseleave)="hideOverlayPanel(opInvoice)">
              <div
                #imgWrapperVideoInvoice
                class="header"
                [ngClass]="
                  typeOfPolicy === 'invoice' ? 'header--isActive' : 'header'
                "
                tabindex="0"
                (click)="selectTypeOfPolicy('invoice')"
                (keyup.enter)="selectTypeOfPolicy('invoice')">
                <div class="p-d-flex p-ai-center">
                  <p>{{ t('tab.header1.videoLong') }}</p>
                  <div class="imgWrapper">
                    <img
                      src="assets/icons/info.svg"
                      class="p-mx-2"
                      alt="info"
                      loading="lazy"
                      decoding="async"
                      tabindex="0"
                      (mouseover)="opInvoice.show($event)"
                      (focus)="opInvoice.show($event)" width="19" height="23">
                    <p-overlayPanel
                      #opInvoice
                      [dismissable]="true"
                      [showTransitionOptions]="'200ms'"
                      [appendTo]="imgWrapperVideoInvoice"
                      [baseZIndex]="50000">
                      <ng-template pTemplate>
                        <div (mouseleave)="opInvoice.hide()">
                          <div class="p-mb-2">
                            <div class="textGrey">
                              <span class="p-text-bold">{{
                                t('tab.header1.long')
                              }}</span>
                              <span
                                [innerHTML]="t('tab.header1.content')"></span>
                            </div>
                          </div>
                          <a
                            routerLink="/"
                            fragment="benefits"
                            >{{ t('tab.showMore') }}</a
                          >
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                </div>
                <span class="p-text-light p-d-xl-block">{{
                  t('tab.header1.short')
                }}</span>
                <p
                  class="p-text-small p-mt-2"
                  [innerHTML]="t('tab.header1.description')"></p>
              </div>
            </div>

            <div
              class="p-col-12 p-md-4 header-stretch"
              (mouseleave)="hideOverlayPanel(opCasco)">
              <div
                #imgWrapperVideoCasco
                class="header"
                [ngClass]="
                  typeOfPolicy === 'casco' ? 'header--isActive' : 'header'
                "
                tabindex="0"
                (click)="selectTypeOfPolicy('casco')"
                (keyup.enter)="selectTypeOfPolicy('casco')">
                <div class="p-d-flex p-ai-center">
                  <p>{{ t('tab.header2.videoLong') }}</p>
                  <div class="imgWrapper">
                    <img
                      src="assets/icons/info.svg"
                      class="p-mx-2"
                      alt="info"
                      loading="lazy"
                      decoding="async"
                      tabindex="0"
                      (mouseover)="opCasco.show($event)"
                      (focus)="opCasco.show($event)" width="19" height="23">
                    <p-overlayPanel
                      class="centralPanel"
                      #opCasco
                      [dismissable]="true"
                      [showTransitionOptions]="'200ms'"
                      [appendTo]="imgWrapperVideoCasco"
                      [baseZIndex]="50000">
                      <ng-template pTemplate>
                        <div (mouseleave)="opCasco.hide()">
                          <div class="p-mb-2">
                            <div class="textGrey">
                              <span class="p-text-bold">{{
                                t('tab.header2.long')
                              }}</span>
                              <span
                                [innerHTML]="t('tab.header2.content')"></span>
                            </div>
                          </div>
                          <a
                            routerLink="/"
                            fragment="benefits"
                            >{{ t('tab.showMore') }}</a
                          >
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                </div>
                <span class="p-text-light p-d-xl-block">{{
                  t('tab.header2.short')
                }}</span>
                <p
                  class="p-text-small p-mt-2"
                  [innerHTML]="t('tab.header2.description')"></p>
              </div>
            </div>

            <div
              class="p-col-12 p-md-4 header-stretch"
              (mouseleave)="hideOverlayPanel(opDirect)">
              <div
                #imgWrapperVideoDirect
                class="header"
                [ngClass]="
                  typeOfPolicy === 'direct' ? 'header--isActive' : 'header'
                "
                tabindex="0"
                (click)="selectTypeOfPolicy('direct')"
                (keyup.enter)="selectTypeOfPolicy('direct')">
                <div class="p-d-flex p-ai-center">
                  <p>{{ t('tab.header3.videoLong') }}</p>
                  <div class="imgWrapper">
                    <img
                      src="assets/icons/info.svg"
                      class="p-mx-2"
                      alt="info"
                      loading="lazy"
                      decoding="async"
                      tabindex="0"
                      (mouseover)="opDirect.show($event)"
                      (focus)="opDirect.show($event)" width="19" height="23">
                    <p-overlayPanel
                      class="rightSidePanel"
                      #opDirect
                      [dismissable]="true"
                      [showTransitionOptions]="'200ms'"
                      [appendTo]="imgWrapperVideoDirect"
                      [baseZIndex]="50000">
                      <ng-template pTemplate>
                        <div (mouseleave)="opDirect.hide()">
                          <div class="p-mb-2">
                            <div class="textGrey">
                              <span class="p-text-bold">{{
                                t('tab.header3.long')
                              }}</span>
                              <span
                                [innerHTML]="t('tab.header3.content')"></span>
                            </div>
                          </div>
                          <a
                            routerLink="/"
                            fragment="benefits"
                            >{{ t('tab.showMore') }}</a
                          >
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                </div>
                <span class="p-text-light p-d-xl-block">{{
                  t('tab.header3.short')
                }}</span>
                <p
                  class="p-text-small p-mt-2"
                  [innerHTML]="t('tab.header3.description')"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="benefits__description">
          <p [innerHTML]="t('benefits.content.col3.content')"></p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
